import { Grid } from '@material-ui/core';
import { inject } from 'mobx-react';
import React from 'react';
import {
    HorizontalGridLines,
    RadialChart,
    VerticalBarSeries,
    VerticalGridLines,
    XAxis,
    XYPlot,
    YAxis,
} from 'react-vis';
import {
    AffinityClusterObservationStatsDto,
    DashboardObservationStatsDto,
} from 'src/generated_client';
import { IStores } from 'src/Stores';
import ObservationStatsLogic from './ObservationStatsLogic';
interface IObservationStatsProps {
    dashboardStats?: DashboardObservationStatsDto;
}

class ObservationStats extends React.Component<IObservationStatsProps> {
    private _logic: ObservationStatsLogic = new ObservationStatsLogic();

    private getAffinityClusterBarChartDataPoints(
        affinityClusterStats: AffinityClusterObservationStatsDto[]
    ) {
        const affinityClusterBars = new Array<JSX.Element>();
        const dataPoints = this._logic.getAffinityClusterBarDataPoints(affinityClusterStats);

        dataPoints.forEach((x) => affinityClusterBars.push(<VerticalBarSeries data={x} />));

        return affinityClusterBars;
    }

    public render() {
        const { dashboardStats } = this.props;

        return (
            <Grid container direction="column">
                <Grid item>
                    <h3 id="observationStats" style={{ marginLeft: '20px', color: '#2429cb' }}>
                        Observation Stats
                    </h3>
                </Grid>
                <Grid item>
                    {dashboardStats!.observationStats!.length > 0 ? (
                        <Grid container direction="row" justify="space-around">
                            <Grid item>
                                <Grid container direction="column" alignItems="center">
                                    <Grid item>
                                        <h4>
                                            {this._logic.getTotalObservations(dashboardStats!)}{' '}
                                            Observations
                                        </h4>
                                    </Grid>
                                    <Grid item>
                                        <RadialChart
                                            data={this._logic.getObservationRadialDataPoints(
                                                dashboardStats!
                                            )}
                                            width={400}
                                            height={400}
                                            showLabels={true}
                                            innerRadius={75}
                                            radius={100}
                                            labelsRadiusMultiplier={1.9}
                                            colorType={'literal'}
                                            margin={{ bottom: 50 }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container direction="column" alignItems="center">
                                    <Grid item>
                                        <h4>Affinity Cluster Breakdown</h4>
                                    </Grid>
                                    <Grid item>
                                        <div>
                                            <XYPlot
                                                height={500}
                                                width={800}
                                                stackBy="y"
                                                colorType={'literal'}
                                                xType="ordinal"
                                                margin={{ bottom: 200 }}
                                            >
                                                <VerticalGridLines
                                                    style={{
                                                        stroke: 'black',
                                                        strokeWidth: 0.5,
                                                    }}
                                                />
                                                <HorizontalGridLines
                                                    style={{
                                                        stroke: 'black',
                                                        strokeWidth: 0.5,
                                                    }}
                                                />
                                                {this.getAffinityClusterBarChartDataPoints(
                                                    dashboardStats!.affinityClusterObservationStats!
                                                )}
                                                <XAxis tickLabelAngle={-45} />
                                                <YAxis />
                                            </XYPlot>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid container direction="row" justify="center">
                            <Grid item>
                                <h3 style={{ color: 'red' }}>No Observations</h3>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        );
    }
}

const InjectedObservationStats = inject<
    IStores,
    IObservationStatsProps,
    Partial<IObservationStatsProps>,
    any
>(() => ({}))(ObservationStats);

export default InjectedObservationStats;



// WEBPACK FOOTER //
// ./src/dashboardRows/ObservationStats/ObservationStats.tsx